import $ from 'jquery';
import { globalNotifyError, globalNotifySuccess } from 'views/utilities/AlertToast';

export const handleCapture = (deviceName, onSuccess, aepsType, otp, kyc) => {
    if (!deviceName) {
        globalNotifyError('Device name is required');
        return;
    }
    let xml;
    if (aepsType == 2) {
        if (kyc == 1) {
            console.log('kyc');
            xml = `<?xml version="1.0"?>
            <PidOptions ver="1.0">
                <Opts fCount="1" fType="2" iCount="0" pCount="0" pType="0" pgCount="2" format="0" iType="0" pidVer="2.0" timeout="10000" pTimeout="20000" posh="UNKNOWN"  wadh="18f4CEiXeXcfGXvgWA/blxD+w2pw7hfQPY45JMytkPw=" env="P" otp="${
                    otp || ''
                }" />
                <CustOpts>
                    <Param name="mantrakey" value="Type1Key" />
                </CustOpts>
            </PidOptions>`;
        } else {
            xml = `<?xml version="1.0"?>
            <PidOptions ver="1.0">
                <Opts fCount="1" fType="2" iCount="0" pCount="0" pType="0" pgCount="2" format="0" iType="0" pidVer="2.0" timeout="10000" pTimeout="20000" posh="UNKNOWN" env="P" otp="${
                    otp || ''
                }" />
                <CustOpts>
                    <Param name="mantrakey" value="Type1Key" />
                </CustOpts>
            </PidOptions>`;
        }
    } else if (aepsType === 3) {
        xml = `<?xml version="1.0"?>
        <PidOptions ver='1.0'> <Opts fCount='1' fType='2' iCount='0' iType='0' indicatorforUID='0' pCount='0'q
pType='0' format='0' pidVer='2.0' env='P' timeout='10000' otp='${otp || ''}'
wadh='E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc='
posh='UNKNOWN'/><Demo></Demo><CustOpts> <Param name='' value='' /></CustOpts></PidOptions>`;
    } else {
        xml = `<?xml version="1.0"?>
        <PidOptions ver="1.0">
          <Opts fCount="1" fType="2" iCount="0" pCount="0" pType="0" pgCount="2" format="0" iType="0" pidVer="2.0" timeout="10000" pTimeout="20000" posh="UNKNOWN" env="P" otp="${
              otp || ''
          }" />
          <CustOpts>
            <Param name="mantrakey" value="" />
          </CustOpts>
        </PidOptions>`;
    }

    const deviceUrls = {
        MFS110: 'https://127.0.0.1:11100/rd/capture',
        MSO1300E3: 'https://127.0.0.1:11100/capture',
        FM220UL1: 'https://localhost:11200/rd/capture',
        PB1000: 'http://127.0.0.1:11100/rd/capture',
        AST300: 'https://localhost:11200/rd/capture'
    };

    function getErrorInfo(xmlString) {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlString, 'text/xml');
        const respElement = xmlDoc.querySelector('Resp');

        if (respElement && respElement.getAttribute('errInfo')) {
            return respElement.getAttribute('errInfo');
        }
        return null; // Return null if errInfo is not present
    }
    function getErrorInfo(xmlData) {
        const xmlString = typeof xmlData === 'string' ? xmlData : new XMLSerializer().serializeToString(xmlData);

        const match = xmlString.match(/errInfo="([^"]+)"/);
        return match ? match[1] : null;
    }

    const url = deviceUrls[deviceName.replace(/\s+/g, '')];
    if (!url) {
        globalNotifyError('Unsupported device');
        return;
    }

    if (deviceName.replace(/\s+/g, '') === 'FM220UL1' || deviceName.replace(/\s+/g, '') === 'AST300') {
        $.ajax({
            type: 'CAPTURE',
            async: false,
            crossDomain: true,
            url: 'https://localhost:11200/rd/capture',
            data: xml,
            contentType: 'text/xml; charset=utf-8',
            processData: false,
            success: function (data) {
                var xmlString = typeof data === 'string' ? data : new XMLSerializer().serializeToString(data);
                $('div.spanner').addClass('show');
                $('#txtPidData').val(xmlString);
                const errorMessage = getErrorInfo(xmlString);
                // Call onSuccess only if errorMessage is null or empty
                if (!errorMessage) {
                    onSuccess && onSuccess(xmlString);
                } else {
                    const message = '';
                    onSuccess && onSuccess(message);
                    globalNotifyError(errorMessage);
                }

                return false;
            },
            error: function (jqXHR) {
                $('div.spanner').removeClass('show');
                globalNotifyError('Please Connect Your Biometric Device');
                console.log('Error:', jqXHR);
            }
        });
    } else {
        $.ajax({
            type: 'CAPTURE',
            async: false,
            crossDomain: true,
            url: url,
            data: xml,
            contentType: 'text/xml; charset=utf-8',
            processData: false,
            success: function (data) {
                $('div.spanner').addClass('show');
                $('#txtPidData').val(data);
                const xmlString = data;

                const error = getErrorInfo(xmlString);
                if (error === 'Success.') {
                    globalNotifySuccess('Finger Capture Success');
                    onSuccess && onSuccess(data);
                } else {
                    globalNotifyError(error);
                    const message = '';
                    onSuccess && onSuccess(message);
                }
            },
            error: function (jqXHR) {
                $('div.spanner').removeClass('show');
                globalNotifyError('Please Connect Your Biometric Device');
                console.log('Error:', jqXHR);
            }
        });
    }
};
